// @ts-strict-ignore
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromVehicleSchedule from '../reducers/vehicle-schedule.reducer';
import { getOperators } from './employee.selectors';
import { getCurrentDay } from '@fc-shared/ui/shcedule-calendar/store/schedule-calendar.selectors';
import moment from 'moment/moment';
import * as fromVehicleSchedules from '@fc-store/reducers/vehicle-schedule.reducer';

export const getVehicleScheduleState =
  createFeatureSelector<fromVehicleSchedules.State>(fromVehicleSchedules.key);

export const getVehicleSchedule = createSelector(
  getVehicleScheduleState,
  fromVehicleSchedule.getVehicleSchedules,
);
export const getVehicleScheduleLoading = createSelector(
  getVehicleScheduleState,
  fromVehicleSchedule.getLoading,
);
export const getVehicleScheduleError = createSelector(
  getVehicleScheduleState,
  fromVehicleSchedule.getError,
);
export const getAvailableOperators = createSelector(
  getOperators,
  getVehicleSchedule,
  getCurrentDay,
  (operators, vehicleSchedule, currentDay) => {
    const filteredByDay = vehicleSchedule.filter((schedule) =>
      currentDay?.date.isBetween(
        moment(schedule.duration.lower),
        moment(schedule.duration.upper),
        'hours',
        '[]',
      ),
    );
    return operators.filter(
      (item) =>
        !filteredByDay.find(
          (schedule) => schedule?.operator === item.operator?.id,
        ),
    );
  },
);
